module.exports = __webpack_public_path__ + "static/media/Download_PDF.40c24a34.svg";